import {ApiV0Administration} from '../api.v0.administration';
import {RestApiService} from '../../../rest-api.service';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {Observable} from 'rxjs';
import {AVariableReq, AVariableRes} from '../../../../contracts/v0/administration/variable.contracts';

export class ApiV0AdminVariables {
    segment = '/variables';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    search(dto?: SearchModel): Observable<BaseCollectionModel<AVariableRes>> {
        dto = dto ?? new SearchModel({});
        return this.rest.post<SearchModel, BaseCollectionModel<AVariableRes>>(`${this.segment}/search`, AVariableRes, dto);
    }

    update(id: number, req: AVariableReq) {
        return this.rest.patch<AVariableReq, AVariableRes>(
            `${this.segment}/${id}`,
            AVariableRes,
            req
        );
    }
}